import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

const Notification: React.FC = () => <Toaster position='top-center' reverseOrder={false} />;

type NotificationType = 'success' | 'error';

const formatMessage = (message: unknown): string => {
	if (typeof message === 'string' && message.trim() !== '') {
		return message.charAt(0).toUpperCase() + message.slice(1);
	}
	if (message instanceof Error && message.message) {
		return message.message.charAt(0).toUpperCase() + message.message.slice(1);
	}
	return 'Something went wrong';
};

export const notify = (message: unknown, type?: NotificationType, options: any = {}) => {
	const msg = formatMessage(message);

	options = {
		duration: 3000,
		icon: null,
		style: {
			background: '#dc3545',
			color: '#FFFFFF',
			fontWeight: 500
		},
		...options
	};

	if (type === 'success') {
		toast.success(msg, { ...options, style: { ...options.style, background: '#28a745' } });
	} else if (type === 'error') {
		toast.error(msg, { ...options, style: { ...options.style, background: '#dc3545' } });
	} else {
		toast(msg, options);
	}
};

export default Notification;
